import { render, staticRenderFns } from "./FormItemField.vue?vue&type=template&id=f479c1da&scoped=true&"
import script from "./FormItemField.vue?vue&type=script&lang=js&"
export * from "./FormItemField.vue?vue&type=script&lang=js&"
import style0 from "./FormItemField.vue?vue&type=style&index=0&id=f479c1da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f479c1da",
  null
  
)

export default component.exports